import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


import Categorie from './components/Categorie/Categorie';
import SousService from './components/SousService/SousService';
import Annonce from './components/Annonce/Annonce';
import DetailAnnonce from './components/DetailAnnonce/DetailAnnonce';
import Evenement from './components/Evenement/Evenement';
import Message from './components/Message/Message';
import Home from './components/Home/Home';
import Connexion from './components/Auth/Connexion';
import Inscription from './components/Auth/Inscription';
import UserSpace from './components/UserSpace/UserSpace';
import AjoutAnnonceUser from './components/Annonce/AjoutAnnonceUser';
import Contact from './components/Contact/Contact';
import AnnonceUser from './components/UserSpace/AnnonceUser';
import MessageUser from './components/UserSpace/MessageUser';
import DiscussionList from './components/forum/DiscussionList';
// Import des composants Admin
import Annonces from './components/administrateur/annonces/annonces';
import Evenements from './components/administrateur/evenements/evenements';
import Messages from './components/administrateur/messages/messages';
import SousServices from './components/administrateur/sousservice/sousservice';
import Users from './components/administrateur/users/users';
import AccueilAdmin from './components/administrateur/accueil/accueil';
import AjoutAnnonce from './components/administrateur/annonces/AjoutAnnonce';
import EvenementInscription from './components/EvenementInscription/EvenementInscription';
import CreerEvenement from './components/administrateur/evenements/CreerEvenement';
import ContactList from './components/administrateur/contact/ContactList';
import APropos from './components/a-propos/a-propos';
import Forum from './components/forum/Forum';
import UserUpdateprofil from './components/UserSpace/UserUpdateprofil';
import UserUpdateannonce from './components/UserSpace/UserUpdateannonce';

import GeminiChat from './components/GeminiChat';
import VerifyEmailPage from './components/Auth/VerifyEmailPage';
import InscriptionSuccess from './components/Auth/InscriptionSuccess';

import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import EnAttenteVerification from './components/Auth/EnAttenteVerification';
import ListeExperts from './components/listeexpert/ListeExperts';
import DetailsExpert from './components/listeexpert/DetailsExpert';
import TopMenu from './components/topmenu/TopMenu';
import Messagerecu from './components/messagerecu/Messagerecu';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categorie" element={<Categorie />} />
        <Route path="/sousservice" element={<SousService />} />
        <Route path="/annonces" element={<Annonce />} />
        <Route path="/annonces/:id" element={<DetailAnnonce />} />
        <Route path="/evenements" element={<Evenement />} />
        <Route path="/message" element={<Message />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/mon-compte" element={<UserSpace />} />
        <Route path="/mes-annonces" element={<AnnonceUser />} />
        <Route path="/mes-messages" element={<MessageUser />} />
        <Route path="/verify-email/:id/:hash" element={<VerifyEmailPage />} />
        <Route path="/inscription/confirmation-email" element={<InscriptionSuccess />} />
        <Route path="/inscription/en-attente-verification" element={<EnAttenteVerification />} />
        
        <Route path="/experts/:id" element={<DetailsExpert />} />
        <Route path="/messages" element={<Messagerecu />} />

        <Route path="/experts" element={<ListeExperts />} />
         {/* Routes pour l'administration */}
        <Route path="/admin/annonces" element={<Annonces />} />
        <Route path="/admin/evenements" element={<Evenements />} />
        <Route path="/admin/messages" element={<Messages />} />
        <Route path="/admin/sous-services" element={<SousServices />} />
        <Route path="/admin/utilisateurs" element={<Users />} />
        <Route path="/admin/contacts" element={<ContactList />} />
        <Route path="/a-propos" element={<APropos />} />
        <Route path="/admin" element={<AccueilAdmin />} />
        <Route path="/forum" element={<Forum />} />
        <Route path="/discussion" element={<DiscussionList />} />
         {/* Route pour l'ajout d'une nouvelle annonce */}
        <Route path="/admin/annonces/creer" element={<AjoutAnnonce />} />
        <Route path="/modifier-profil" element={<UserUpdateprofil />} />
        <Route path="/modifier-annonce/:id" element={<UserUpdateannonce />} />
        <Route path="/assistant-ai" element={<GeminiChat />} />

        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

         <Route 
          path="/evenements/:evenementId/inscription" 
          element={<EvenementInscription />} 
          
        />

              {/* Route pour créer un nouvel événement */}
        <Route path="/admin/evenements/ajouter" element={<CreerEvenement />} />

        <Route path="/ajouter-annonce" element={<AjoutAnnonceUser />} />
              <Route path="/contact" element={<Contact />} />
               
      </Routes>

<TopMenu />

    </Router>
  );
}

export default App;
